export const UNIT_PRESETS = [
  ["pz", "pz (pezzi)"],
  ["ore", "h (ore)"],
  ["m", "m (metri)"],
  ["m2", "m² (metri quadri)"],
  ["m3", "m³ (metri cubi)"],
  ["kg", "kg"],
  ["l", "L (litri)"],
  ["corpo", "a corpo"],
  ["forfait", "forfait"],
  ["giorni", "giorni"],
  ["mese", "mese"],
];
const SHORT = { pz: "pz", ore: "h", m: "m", m2: "m²", m3: "m³", kg: "kg", l: "L", corpo: "a corpo", forfait: "forfait", giorni: "gg", mese: "mese" };
export const isPresetUnit = (u) => Object.prototype.hasOwnProperty.call(SHORT, u);
export const unitShort = (u) => (u ? SHORT[u] || u : "a corpo");
export const isLumpSum = (u) => !u || u === "corpo" || u === "forfait";
export const fmtQty = (q) => Number(q || 0).toLocaleString("it-IT", { maximumFractionDigits: 2 });
export const qtyWithUnit = (q, u) => `${fmtQty(q)} ${unitShort(u)}`;
export const priceSuffix = (u) => (isLumpSum(u) ? unitShort(u) : `/ ${unitShort(u)}`);
